export default __webpack_public_path__ + "static/media/netmeds-immunity-care_without-discount.bbb9a9ba.jpg";